import * as React from 'react'
import { Controller, type FieldValues, type UseControllerProps } from 'react-hook-form'

import NumberField from 'modules/core/components/NumberField'

type NumberFieldProps<TFieldValues extends FieldValues> = Pick<
  UseControllerProps<TFieldValues>,
  'control' | 'name'
> & {
  placeholder?: string
  indicator?: React.ReactNode
  completed?: boolean
  label?: string
  secondaryLabel?: React.ReactNode | React.ReactNode[]
  readonly?: boolean
}

function NumberInputField<TFieldValues extends FieldValues>({
  placeholder,
  indicator,
  readonly,
  label,
  secondaryLabel,
  ...props
}: NumberFieldProps<TFieldValues>): JSX.Element {
  return (
    <Controller
      {...props}
      render={({ field }) => {
        return (
          <NumberField
            {...field}
            label={label}
            completed={props.completed}
            secondaryLabel={secondaryLabel}
            indicator={indicator}
            placeholder={placeholder}
            readonly={readonly}
          />
        )
      }}
    />
  )
}

export { NumberInputField }
